'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.chunkDateRange = exports.formatDate = void 0;
/**
 * Format a date in a way that GiG Core accepts.
 * @param date
 */
function formatDate(date) {
    var NOW = new Date(date.getTime());
    var pad = function (num) { return num.toString().padStart(2, '0'); };
    return (NOW.getFullYear() +
        '/' +
        pad(NOW.getMonth() + 1) +
        '/' +
        pad(NOW.getDate()) +
        'T' +
        pad(NOW.getHours()) +
        ':' +
        pad(NOW.getMinutes()) +
        ':' +
        pad(NOW.getSeconds()));
}
exports.formatDate = formatDate;
/**
 * Splits to and from into chunks of maximum size
 * specified by the maxDays parameter.
 */
function chunkDateRange(from, to, maxDays) {
    if (maxDays === void 0) { maxDays = 60; }
    if (from > to) {
        throw new Error('#chunkDateRange: `from` parameter must be less than `to`');
    }
    var maxMs = maxDays * 24 * 60 * 60 * 1000;
    var ranges = [];
    var fromMs = from.getTime();
    var toMs = to.getTime();
    var divisions = Math.ceil((toMs - fromMs) / maxMs);
    for (var i = 0; i < divisions; i++) {
        var currOffset = i * maxMs;
        var newTo = toMs - currOffset;
        var newFrom = Math.max(fromMs, toMs - (currOffset + maxMs));
        ranges.unshift([newFrom, newTo]);
    }
    return ranges;
}
exports.chunkDateRange = chunkDateRange;
